import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface BankAccounts {
	id: number;
	accountNumber: string;
	name: string;
	balance: number;
	currencyCode: string;
	disponent: boolean;
}

export interface BankAccountsState {
	list: BankAccounts[];
}

function receiveBankAccounts(state: BankAccountsState, { data: accounts }: Action): BankAccountsState {
	const list = accounts.map((a) => ({ ...a, id: Number(a.accountNumber) }));
	return { ...state, list };
}

export const defaultState: BankAccountsState = {
	list: [],
};

export default function bankAccounts(state = defaultState, action: Action) {
	switch (action.type) {
		case actions.BANK_ACCOUNTS_RESPONSE:
			return receiveBankAccounts(state, action);
		default:
			return state;
	}
}
